// extracted by mini-css-extract-plugin
export default {"preloader":"styles_preloader__eaWSf","spinner":"styles_spinner__6p7aa","spin":"styles_spin__Ya-8c"};